import type { Template } from "@/types";

export const LA_01_H0_V1: Template[] = [
{
    id: "la-01-h0v1-01",
    name: "LA 01 - H0V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-01-h0_v1_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 794, y: 30, width: 321, height: 417, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-01-h0v1-02",
    name: "LA 02 - H0V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-01-h0_v1_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 158, y: 30, width: 321, height: 417, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-01-h0v1-03",
    name: "LA 03 - H0V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-01-h0_v1_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 477, y: 30, width: 321, height: 417, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-01-h0v1-04",
    name: "LA 04 - H0V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-01-h0_v1_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 846, y: 0, width: 376, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-01-h0v1-05",
    name: "LA 05 - H0V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-01-h0_v1_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 52, y: 0, width: 376, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-01-h0v1-06",
    name: "LA 06 - H0V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-01-h0_v1_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 899, y: 0, width: 376, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-01-h0v1-07",
    name: "LA 07 - H0V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-01-h0_v1_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 376, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-01-h0v1-08",
    name: "LA 08 - H0V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-01-h0_v1_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 449, y: 0, width: 376, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-01-h0v1-09",
    name: "LA 09 - H0V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-01-h0_v1_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 858, y: 0, width: 416, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-01-h0v1-10",
    name: "LA 10 - H0V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-01-h0_v1_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 416, height: 476, rotation: 0, imageRotation: 0 }
    ],
}
];